module.exports = __webpack_public_path__ + "img/ownership-box.d29fd2c8.svg";